module.exports = __webpack_public_path__ + "static/media/EmptyCircleSVG.44e44913.svg";